import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dt-mainCard__contentWrapper" }
const _hoisted_2 = { class: "dt-mainCard__contentWrapper-tab active" }
const _hoisted_3 = { class: "dt-mainCard__content" }
const _hoisted_4 = { class: "dt-mainCard__content-main" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dt-mainCard__content-infoColumn" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tab_component = _resolveComponent("tab-component")!
  const _component_table_element = _resolveComponent("table-element")!
  const _component_content_editor_element = _resolveComponent("content-editor-element")!
  const _component_gallery_element = _resolveComponent("gallery-element")!
  const _component_files_element = _resolveComponent("files-element")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tab_component, {
      card: $props.card,
      "active-tab": $data.activeTab,
      onChange: $options.changeTab
    }, null, 8 /* PROPS */, ["card", "active-tab", "onChange"]),
    ($data.activeTab)
      ? (_openBlock(), _createElementBlock("div", {
          key: $data.activeTab.id,
          class: "container"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activeTab.mainColumn.elements, (element) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (element['@type'] === 'table')
                        ? (_openBlock(), _createBlock(_component_table_element, {
                            key: 0,
                            element: element
                          }, null, 8 /* PROPS */, ["element"]))
                        : (element['@type'] === 'content-editor')
                          ? (_openBlock(), _createBlock(_component_content_editor_element, {
                              key: 1,
                              element: element
                            }, null, 8 /* PROPS */, ["element"]))
                          : (element['@type'] === 'image-gallery')
                            ? (_openBlock(), _createBlock(_component_gallery_element, {
                                key: 2,
                                element: element
                              }, null, 8 /* PROPS */, ["element"]))
                            : (element['@type'] === 'file-gallery')
                              ? (_openBlock(), _createBlock(_component_files_element, {
                                  key: 3,
                                  element: element
                                }, null, 8 /* PROPS */, ["element"]))
                              : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  _createCommentVNode("                        <div class=\"dt-mainCard__content-block\">\n                                                    <div class=\"dt-mainCard__content-block-title\">\n                                                        Филиалы на карте:\n                                                    </div>\n                                                    <div class=\"dt-element__wrapper dt-element__map bigSize\">\n                                                        карта\n                                                    </div>\n                                                </div>")
                ]),
                _hoisted_5
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}